module.exports = __webpack_public_path__ + "static/img/back-8-1.9e050bb0.png";